import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class KeyStatuses extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			STATUS_NAME: '',
			COMMENTS: ''
		};
		
		var initialKeyStatusList = this.copyKeyStatusList();
		initialKeyStatusList.query.search = this.constructSearch(search);
		
		this.state = {
			renderKey: 1,
			keyStatusList: initialKeyStatusList,
			search: search,
			searchCount: null
		};
	}
	
	copyKeyStatusList() {
		var keyStatusListCopy = this.copyObject(keyStatusList);
		for (var i = 0; i < keyStatusList.columns.length; i++) {
			if (keyStatusList.columns[i].Header) {
				keyStatusListCopy.columns[i].Header = keyStatusList.columns[i].Header;
			}
			if (keyStatusList.columns[i].Cell) {
				keyStatusListCopy.columns[i].Cell = keyStatusList.columns[i].Cell;
			}
		}
		return keyStatusListCopy;
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newKeyStatusList = this.copyKeyStatusList();
		newKeyStatusList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			keyStatusList: newKeyStatusList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.STATUS_NAME)) search.Children.push({ Attribute: 'STATUS_NAME', Operator: 'like', StringValue: '%' + data.STATUS_NAME + '%' });
		if (!this.isEmpty(data.COMMENTS)) search.Children.push({ Attribute: 'COMMENTS', Operator: 'like', StringValue: '%' + data.COMMENTS + '%' });
		
		// if nothing was selected, forget it
		if (search.Children.length === 0) search = null;
		return search;
	}
	
	addKeyStatus() {
		this.props.navigate('/BuildingAccess/KeyStatuses/new');
	}
	
	editKeyStatus(keyStatusId) {
		this.props.navigate('/BuildingAccess/KeyStatuses/' + keyStatusId);		
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Key Statuses',
			columns: exportColumns,
			entity: 'KEY_STATUS_VW',
			search: this.constructSearch(this.state.search),
			order: 'STATUS_NAME'
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Key Statuses</span>
					<ChemEdit parent={this} columns={keyStatusSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_KeyStatuses' table={this.state.keyStatusList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='470px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const keyStatusSearch = [
	{ Header: 'Name', accessor: 'STATUS_NAME', row: 0, col: 0 },
	{ Header: 'Comments', accessor: 'COMMENTS', row: 0, col: 1 }
];

const keyStatusList = {
	query: { entity: 'KEY_STATUS_VW', search: null, order: 'STATUS_NAME' },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addKeyStatus()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editKeyStatus(props.row.values.STATUS_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'STATUS_ID' },
		{ Header: 'Name', accessor: 'STATUS_NAME' },
		{ Header: 'Modified', accessor: 'MODIFIED' },
		{ Header: 'Comments', accessor: 'COMMENTS' }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'STATUS_ID', width: 5 },
	{ Header: 'Name', accessor: 'STATUS_NAME', width: 10 },
	{ Header: 'Modified', accessor: 'MODIFIED', width: 15 },
	{ Header: 'Comments', accessor: 'COMMENTS', width: 20 }
];

export default withRouter(KeyStatuses);